<template lang="pug">
  .color-bar-map-section-v2.container.ui-color-3-bg
    .row.xs-f-small.max-at-tweak
      .inner-wrap.xs-12
        .right-wrap.xs-12.md-6.md-right.lg-right
          .map-container(v-if="location.code")
            HcbGmap(:start-location="location")

        .left-wrap.xs-12.md-6
          p.kapra-neue.brand-color-1.xs-f-grande.md-f-xxgrande.max-at-tweak.mt-50m.mb-100m(v-if="show == 'nearby'") Nearby Hair Color Bars
          p.kapra-neue.brand-color-1.xs-f-grande.md-f-xxgrande.max-at-tweak.mt-50m.mb-100m(v-else) All Hair Color Bars

          .tab-buttons
            button.btn-reset.kapra-neue.upper.xs-f-medium.md-f-large.max-at-tweak(v-if="showNearByTab" type="button" role="tab" id="tab-nearby" aria-controls="tab-content-nearby" @click="show = 'nearby'" :class="{selected: show == 'nearby'}" :aria-selected="show == 'nearby'") nearby locations
            button.btn-reset.kapra-neue.upper.xs-f-medium.md-f-large.max-at-tweak(type="button" role="tab" id="tab-all" aria-controls="tab-content-all" @click="show = 'all'" :class="{selected: show == 'all'}" :aria-selected="show == 'all'") all locations

          .tabs
            .tab-content(v-show="show == 'nearby'" role="tabpanel" id="tab-content-nearby" aria-labelledby="tab-nearby")
              ul
                li.location-wrap(v-for="loc in nearbyMapLocations" :key="loc.code" :class="{selected: selectedMapLocation?.code == loc.code}")
                  .selected-loc.cta-color-1(v-if="selectedMapLocation?.code == loc.code")
                    .icon-wrap
                      MrIcon.cta-color-1.xs-f-large.max-at-tweak(name="map-marker")
                    .selected-loc-inner
                      a.text-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-if="loc.code != location.code" :href="'/colorbar/locations/' + loc.code") {{ loc.name }}
                      p.text-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-else) {{ loc.name }}
                      p.text-color-2.xs-f-small.max-at-tweak {{ loc.shortAddress }}
                      a.mr-btn.xs-f-xxsmall.max-at-tweak(@click="trackMREventAndRedirect('ColorBarMapSectionV2 - Book Appointment Clicked',`/colorbar/booking/${loc.code}/services`)") book appointment
                      a.directions.text-color-1.upper.underline.xs-f-xsmall.max-at-tweak(v-if="loc.mapURL" @click="trackMREventAndRedirect('ColorBarMapSectionV2 - Get Directions Clicked',loc.mapURL)") get directions

                  .loc-info.btn-reset.text-left(v-else)
                    button.btn-reset.icon-wrap(type="button" @click="selectLocation(loc)")
                      MrIcon.text-color-1.xs-f-large.max-at-tweak(name="map-marker" :fill="false")
                      span.ada-tooltip select {{ loc.name }}
                    .loc-info-inner(@click="selectLocation(loc)")
                      a.cta-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-if="loc.code != location.code" :href="'/colorbar/locations/' + loc.code") {{ loc.name }}
                      span.cta-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-else) {{ loc.name }}
                      span.block.text-color-2.xs-f-small.max-at-tweak {{loc.shortAddress}}

            .tab-content(v-show="show == 'all'" role="tabpanel" id="tab-content-all" aria-labelledby="tab-all")
              ul
                li.location-wrap(v-for="loc in mapLocations" :key="loc.code" :class="{selected: selectedMapLocation?.code == loc.code, current: loc.code == location.code}")
                  .selected-loc.cta-color-1(v-if="selectedMapLocation?.code == loc.code")
                    .icon-wrap
                      MrIcon.cta-color-1.xs-f-large.max-at-tweak(name="map-marker")
                    .selected-loc-inner
                      a.text-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-if="loc.code != location.code" :href="'/colorbar/locations/' + loc.code") {{ loc.name }}
                      p.text-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-else) {{ loc.name }}
                      p.text-color-2.xs-f-small.max-at-tweak {{ loc.shortAddress }}
                      a.mr-btn.xs-f-xxsmall.max-at-tweak(href="#" @click="trackMREventAndRedirect('ColorBarMapSectionV2 - Book Appointment Clicked',`/colorbar/booking/${loc.code}/services`)" :aria-label="`Book appointment for ${loc.name}`") book appointment
                      a.directions.text-color-1.upper.underline.xs-f-xsmall.max-at-tweak(href="#" v-if="loc.mapURL" @click="trackMREventAndRedirect('ColorBarMapSectionV2 - Get Directions Clicked',loc.mapURL)") get directions

                  .loc-info.btn-reset.text-left(v-else)
                    button.btn-reset.icon-wrap(type="button" @click="selectLocation(loc)")
                      MrIcon.text-color-1.xs-f-large.max-at-tweak(name="map-marker" :fill="false")
                      span.ada-tooltip select {{ loc.name }}
                    .loc-info-inner(@click="selectLocation(loc)")
                      a.cta-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-if="loc.code != location.code" :href="'/colorbar/locations/' + loc.code") {{ loc.name }}
                      span.cta-color-1.underline.semi-bold.xs-f-medium.max-at-tweak(v-else) {{ loc.name }}
                      span.block.text-color-2.xs-f-small.max-at-tweak {{loc.shortAddress}}

</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  import MrIcon from '@components/MrIcon';
  import HcbGmap from '@components/HcbGmap';

  export default {
    name: "ColorBarMapSectionV2",

    components: {
      MrIcon,
      HcbGmap,
    },

    data() {
      return {
        show: 'nearby'
      };
    },

    computed: {
      ...mapState('colorbar', ['location', 'mapLocations', 'nearbyMapLocations', 'selectedMapLocation']),

      showNearByTab() {
        return this.nearbyMapLocations?.length > 1;
      }
    },


    mounted() {
      if (this.location && this.location.code) {
        this.setSelectedMapLocation(this.location);
      }

      if (!this.showNearByTab) {
        this.show = "all";
      }

    },

    methods: {
      ...mapMutations('colorbar', ['setSelectedMapLocation']),

      selectLocation(loc) {
        this.trackMREvent('HCB Location Page - Nearby location module clicked', { location: loc.code });
        this.setSelectedMapLocation(loc);
      }
    },

  };
</script>

<style scoped lang="stylus">
  .color-bar-map-section-v2
    .inner-wrap
      padding 2.5em 1.3em

      @media mq-desktop-plus
        padding 2.5em 3.2em

    .left-wrap
      padding-right 1.5em

    .tab-buttons
      button
        width 50%
        padding 0.5em 1em
        border-bottom 3px solid text-color-3
        color text-color-2
        text-align left

        &.selected
          border-bottom-color cta-color-1
          color text-color-1

    .tab-content
      max-height 35em
      overflow scroll

      ul
        display flex
        flex-direction column

      .location-wrap
        order 2

        &.current
          order 1

      .selected-loc
        background-color color-white
        box-shadow 0px 4px 8px 0px #0000000F
        width 100%
        position relative
        padding 1.75em 5%
        padding-left 3.5em
        border-radius 0.5em
        margin-top 1.5em

        .icon-wrap
          position absolute
          top 1.5em
          left 1em

        .selected-loc-inner
          .mr-btn
            margin-top 1em
            margin-right 1.5em

      .loc-info
        width 100%
        position relative
        padding 1.75em 5%
        padding-left 3.5em
        border-bottom 1px solid text-color-3

        .icon-wrap
          position absolute
          top 1.5em
          left 1em

    .map-container
      border-radius 0.5em
      overflow hidden

    @media mq-tablet-less
      .inner-wrap
        padding 1.5em 3%

      .right-wrap
        padding-bottom 1.5em

      .left-wrap
        padding-right 0

        .directions
          display block
          margin-top 0.5em

    @media mq-desktop-md-plus
      .right-wrap
        position sticky
        top 0

    @media mq-desktop-md
      .inner-wrap
        padding 2.5em 2%

    @media mq-mobile
      .inner-wrap
        padding 1.5em 0

      .left-wrap
        padding-left 3%
        padding-right 3%

</style>